(function () {
  'use strict';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var ICONS = {
    he: ['M3 7h18v10H3z', 'M7 11h.01M11 11h.01M15 11h.01', 'M8 14h8'],
    mech: ['M3 6h18v12H3z', 'M6 10h.01M10 10h.01M14 10h.01M18 10h.01', 'M7 14h10'],
    mouse: ['M8 3h8a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z', 'M12 3v8'],
    cute: ['M5 21c-1-4 0-9 3-11', 'M19 21c1-4 0-9-3-11', 'M8 10 6 4l4 2.5M16 10l2-6-4 2.5', 'M12 14v4'],
    switch: ['M6 9h12l1 11H5z', 'M9 9V5h6v4', 'M9 13h6'],
    keycap: ['M4 8.5 12 4l8 4.5-8 4.5z', 'M4 8.5v7L12 20l8-4.5v-7', 'M12 13v7'],
    order: ['M4 7h16v13H4z', 'M4 11h16', 'M9 4h6v3H9z'],
  };
  function iconSvg(key) {
    var paths = ICONS[key] || [];
    return '<svg viewBox="0 0 24 24">' + paths.map(function (d) { return '<path d="' + d + '"></path>'; }).join('') + '</svg>';
  }

  var CHEVRON = '<svg class="ak-faq__pick-chevron" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"></path></svg>';
  var ARROW = '<span class="ak-faq__arrow"><svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"></path></svg></span>';

  function getKey() {
    try { return new URLSearchParams(window.location.search).get('c') || ''; }
    catch (e) { return ''; }
  }

  function catHref(key) {
    return window.location.pathname + '?c=' + encodeURIComponent(key);
  }

  function detailsHtml(qa) {
    return '<details class="ak-faq__item"><summary><span class="ak-faq__q">Q</span><span>' +
      esc(qa.q) + '</span>' + ARROW + '</summary><div class="ak-faq__a">' + esc(qa.a) + '</div></details>';
  }

  function render() {
    var d = window.AKKO_FAQ;
    if (!d) return;

    var key = getKey();
    var cat = d.cats[key];

    var main = document.getElementById('faq-main');
    var eyebrow = document.getElementById('faq-eyebrow');
    var title = document.getElementById('faq-title');
    var lead = document.getElementById('faq-lead');
    var crumb = document.getElementById('faq-crumb');
    var index = document.getElementById('faq-index');
    var chips = document.getElementById('faq-chips');
    var groups = document.getElementById('faq-groups');
    var cta = document.getElementById('faq-cta');

    if (eyebrow) eyebrow.textContent = d.eyebrow || '';

    if (!cat) {
      // インデックス（?c= 無し、または未知のキー）
      if (title) title.textContent = d.indexTitle || '';
      if (lead) lead.textContent = d.indexLead || '';
      if (crumb) crumb.textContent = d.indexTitle || '';
      if (index) {
        index.innerHTML = d.order.map(function (k) {
          var c = d.cats[k];
          return '<a class="ak-faq__pick" href="' + esc(catHref(k)) + '">' +
            '<span class="ak-faq__pick-icon">' + iconSvg(c.icon || k) + '</span>' +
            '<span class="ak-faq__pick-text">' +
            '<span class="ak-faq__pick-label">' + esc(c.label) + '</span>' +
            '<span class="ak-faq__pick-desc">' + esc(c.desc) + '</span>' +
            '</span>' + CHEVRON + '</a>';
        }).join('');
        index.hidden = false;
      }
      if (chips) { chips.innerHTML = ''; chips.hidden = true; }
      if (groups) groups.innerHTML = '';
    } else {
      // 詳細
      if (title) title.textContent = cat.label + 'のよくあるご質問';
      if (lead) lead.textContent = cat.lead || '';
      if (crumb) crumb.textContent = cat.label;
      if (index) index.hidden = true;
      if (chips) {
        chips.innerHTML = d.order.map(function (k) {
          return '<a class="ak-faq__chip' + (k === key ? ' is-current' : '') + '" href="' +
            esc(catHref(k)) + '">' + esc(d.cats[k].label) + '</a>';
        }).join('');
        chips.hidden = false;
      }
      if (groups) {
        groups.innerHTML = cat.groups.map(function (g) {
          return '<div class="ak-faq__group"><h2 class="ak-faq__group-title">' + esc(g.title) + '</h2>' +
            g.items.map(detailsHtml).join('') + '</div>';
        }).join('');
      }
    }

    if (cta && d.cta) {
      cta.innerHTML = '<div><h3>' + esc(d.cta.heading) + '</h3><p>' + esc(d.cta.text) + '</p></div>' +
        '<a href="' + esc(d.cta.href) + '">' + esc(d.cta.label) + '</a>';
      cta.hidden = false;
    }

    if (main) main.hidden = false;
  }

  if (window.AKKO_FAQ) render();
  else document.addEventListener('DOMContentLoaded', render);
  window.addEventListener('popstate', render);
})();
